<template>
    <div id="time-picker">
        <b-input-group class="gy-date-time-picker">
            <b-form-input
                id="time-start-input"
                v-model="timeInputComputed"
                type="text"
                :placeholder="placeholder"
                autocomplete="off"
                :class="errorMessage ? 'border-danger' : ''"
            ></b-form-input>
            
            <b-input-group-append>
                <b-form-timepicker
                    v-model="timePickerComputed"
                    button-only
                    right
                    aria-controls="time-start-input"
                    :locale="locale"
                ></b-form-timepicker>
            </b-input-group-append>
        </b-input-group>

        <div class="text-danger" style="font-size: 12px;" v-if="errorMessage">
            {{$trans(errorMessage)}}
        </div>
    </div>
</template>

<script>
const timeRegex = /^((1[0-2]|0?[1-9]):([0-5][0-9])\s ?([AaPp][Mm]))$/g;

export default {
    props: {
        isRequired: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: 'HH:MM AM/PM'
        },
    },
    data() {
        return {
            errorMessage: "",
            time: null,
            locale: "en",
        }
    },
    computed: {
        timeInputComputed: {
            get() {
                if (this.checkTimeRegex(this.value)) {
                    this.time = new Date("1970-01-01 " + this.value);
                }

                return this.value;
            },
            set(value) {
                this.updateValue(value);
            }
        },
        timePickerComputed: {
            get() {
                if (this.time) {
                    return this.time.toLocaleTimeString(
                        'en-US',
                        { hour: "2-digit", minute: "2-digit", hour12: false, }
                    ) + ":00";
                } else {
                    return null;
                }
            },
            set(value) {
                this.timeInputComputed = new Date('1970-01-01T' + value)
                    .toLocaleTimeString(
                        'en-US',
                        { hour12: true, hour: 'numeric', minute: 'numeric' }
                    );
            }
        }
    },
    methods: {
        updateValue(value) {
            let isInvalid = this.checkTimeFormat(value);
            
            if(!isInvalid && value) {
                this.time = new Date("1970-01-01 " + value);
            }
            
            this.$emit(
                "update:value",
                {
                    value: value,
                    error: isInvalid
                }
            );
        },
        checkTimeFormat(value) {
            if (!value) {
                if (this.isRequired) {
                    this.errorMessage = this.$trans("Time is required.");
                    return true;
                }
                else {
                    this.errorMessage = "";
                    return false;
                }
            }
    
            if (!value.match(timeRegex)) {
                this.errorMessage = this.$trans("Invalid time. Please enter using format: HH:MM AM/PM.");
                return true;
            }

            this.errorMessage = "";
            return false;
        },
        checkTimeRegex(timeString) {
            if (timeString === null) {
                return false;
            }

            if (!timeString && !timeString?.length) {
                return true;
            }
            
            if (!timeString.match(timeRegex)) {
                return false;
            }

            return true;
        }
    }
}
</script>